import { preview } from '@/components/form/preview'

import { Header } from './components/Header'

interface Props {
  selection: workwave.DeepReadonly<string[]>
  driverAssignments: uui.domain.client.rm.DriverAssignmentsWithId[]
}

export function BulkView(props: Props) {
  const { driverAssignments } = props

  return (
    <preview.Root
      applyPendingFitMapOnMount
      header={<Header driverAssignments={driverAssignments} />}
    />
  )
}
